import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import at from 'lodash/at'

import IssueTabs from '../../components/issues/issue-tabs'

const tabNames = [
  'comments',
  'history'
]

function mapStateToProps (state, ownProps) {
  const selectedTab = tabNames.indexOf(ownProps.location.query.tab)

  return { selectedTab }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onTabSelect (tabIndex) {
      dispatch(replace({
        pathname: ownProps.location.pathname,
        query: { tab: tabNames[tabIndex] }
      }))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueTabs)



// WEBPACK FOOTER //
// ./src/containers/issues/issue-tabs-container.js